import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { MailTemplateVisualEditorOptionsSection } from "./mailTemplateVisualEditorOptionsSection";
import { MailTemplateVisualEditorNumberPicker } from "./mailTemplateVisualEditorNumberPicker";

type Props = {
    borderRadius: number,
    onChangeBorderRadius: (value: number) => void
}

export function MailTemplateVisualEditorBorderRadiusOption(props: Props): JSX.Element {
    const { t } = useTranslation();
    return (
        <MailTemplateVisualEditorOptionsSection>
            <Typography>{t<string>('shared.mail-template-visual-editor-border-radius')}</Typography>
            <MailTemplateVisualEditorNumberPicker
                measureUnit="px"
                value={props.borderRadius}
                onChange={props.onChangeBorderRadius}
            />
        </MailTemplateVisualEditorOptionsSection>
    );
}
